<!-- Footer opened -->
<div class="main-footer ht-40 no-print">
    <div class="container-fluid pd-t-0-f ht-100p">
        <span>Copyright © {{year}} <a href="https://anjaconline.org">Ayya Nadar Janaki Ammal College</a>. All rights reserved.</span>
    </div>
</div>
<!-- Footer closed -->